// extracted by mini-css-extract-plugin
export default {"form":"LoginForm_form__SlpAq","title":"LoginForm_title__O4ZeX","button":"LoginForm_button__IvhVx","navigate":"LoginForm_navigate__yJROi"};